import { createAction } from "../../../Common/_actions/Action";
import { StoreProductListPayload } from "../../_stores/Store/StoreProductListStore";
import { StoreProductPayload } from "../../_stores/Store/StoreProductStore";

export enum StoreProductStoreActionType {
  EditStoreProduct = 'STORE_PRODUCT_EDIT_STORE_PRODUCT',
  EditManyStoreProducts = 'STORE_PRODUCT_EDIT_MANY_STORE_PRODUCTS',
  InvalidateStoreProducts = 'STORE_PRODUCT_INVALIDATE_STORE_PRODUCTS',
  EditStoreProductList = 'STORE_PRODUCT_EDIT_STORE_PRODUCT_LIST',
  EditStoreProductListLoader = 'STORE_PRODUCT_EDIT_STORE_PRODUCT_LIST_LOADER',
}

export const EditStoreProduct = (storeType: string, storeProduct: StoreProductPayload) => createAction(StoreProductStoreActionType.EditStoreProduct, {
  storeType: storeType,
  storeProduct: storeProduct
});

export const EditManyStoreProducts = (storeType: string, storeProducts: Record<string, StoreProductPayload>) => createAction(StoreProductStoreActionType.EditManyStoreProducts, {
  storeType: storeType,
  storeProducts: storeProducts
});

export const InvalidateStoreProducts = (storeType: string) => createAction(StoreProductStoreActionType.InvalidateStoreProducts, {
  storeType: storeType,
});

export const EditStoreProductList = (storeType: string, listId: string, data:StoreProductListPayload) => createAction(StoreProductStoreActionType.EditStoreProductList, {
  storeType: storeType,
  listId: listId,
  data: data
})

export const EditStoreProductListLoader = (storeType: string, listId: string, loading:boolean) => createAction(StoreProductStoreActionType.EditStoreProductListLoader, {
  storeType: storeType,
  listId: listId,
  loading: loading
})

export type StoreProductStoreAction =
    ReturnType<typeof EditStoreProduct> |
    ReturnType<typeof EditManyStoreProducts> |
    ReturnType<typeof EditStoreProductList> |
    ReturnType<typeof EditStoreProductListLoader> |
    ReturnType<typeof InvalidateStoreProducts>
